import React from 'react'

const ErrorPage = () => {
  return <div>The Page You were trying to access is not available</div>;
}

export default ErrorPage